/**
 * PageView Webhook for India Market
 * 
 * Sends PageView event to n8n on every page load
 */

(function() {
  'use strict';
  
  // Check if helper is available
  if (!window.WebhookHelperIndia || !window.WebhookHelperIndia.isIndiaMarket()) {
    return;
  }
  
  // Get page type from body class or URL
  function getPageType() {
    const bodyClass = document.body.className;
    if (bodyClass.includes('template-product')) return 'product';
    if (bodyClass.includes('template-collection')) return 'collection';
    if (bodyClass.includes('template-cart')) return 'cart';
    if (bodyClass.includes('template-index')) return 'home';
    if (bodyClass.includes('template-page')) return 'page';
    
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/products/')) return 'product';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/cart')) return 'cart';
    if (path === '/') return 'home';
    
    return 'other';
  }
  
  // Send PageView webhook
  function sendPageViewWebhook() {
    window.WebhookHelperIndia.sendWebhook('PageView', {
      custom_data: {
        page_type: getPageType(),
        page_path: window.location.pathname,
        page_title: document.title,
        currency: 'INR',
        market: 'India'
      }
    });
  }
  
  // Fire on page load (only once)
  if (document.readyState === 'complete') {
    sendPageViewWebhook();
  } else {
    window.addEventListener('load', sendPageViewWebhook, { once: true });
  }
  
})();
